import { Link } from 'gatsby'
import React from 'react'


function Logo({}) {
  let str = ""
  if (typeof window !== 'undefined')
  {
      let location = window.location.pathname
      str = location.replace(/^\/([^\/]*).*$/, '$1')
  }
  return (

    <Link to ={str =='fr-fr' ? '/fr-fr' : '/'}>
<svg width="120" height="35" viewBox="0 0 120 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_693_145)">
<path d="M31.4629 20.0991H33.5562L36.7843 29.8873H36.8193L40.0474 20.0991H42.1415L37.8142 32.2937H35.7901L31.4629 20.0991Z" fill="#39394C"/>
<path d="M44.584 20.0991H46.6081V32.2937H44.584V20.0991Z" fill="#39394C"/>
<path d="M49.75 30.4973V28.9643H51.7391V29.8903L52.4022 30.5521H56.2062L56.9043 29.8554V27.6057L56.2234 26.9268H51.5842L49.7871 25.1502V21.8931L51.5842 20.0994H56.9585L58.7535 21.8931V23.4433H56.7644V22.5029L56.0842 21.8411H52.4543L51.7741 22.5029V24.5233L52.4543 25.1851H57.0934L58.8905 26.9788V30.4624L57.0613 32.2939H51.5471L49.75 30.4973Z" fill="#39394C"/>
<path d="M61.9453 20.0994H63.9687V32.2939H61.9453V20.0994Z" fill="#39394C"/>
<path d="M67.1973 30.3228V22.0677L69.1693 20.0994H75.2065L77.1785 22.0677V30.3228L75.2065 32.2939H69.1693L67.1973 30.3228ZM74.1595 30.5493L75.1544 29.574V22.8192L74.1595 21.844H70.2163L69.2221 22.8192V29.5769L70.2163 30.5521L74.1595 30.5493Z" fill="#39394C"/>
<path d="M80.3198 20.0994H82.1697L87.928 28.9643H87.9629V20.0994H89.8999V32.2939H88.0486L82.2903 23.4461H82.2554V32.2939H80.3184L80.3198 20.0994Z" fill="#39394C"/>
<path d="M96.6001 20.0994H98.5193L102.934 32.2939H100.875L99.8282 29.4024H95.274L94.227 32.2939H92.168L96.6001 20.0994ZM99.3572 27.7105L97.5601 22.5549H97.5251L95.7622 27.7105H99.3572Z" fill="#39394C"/>
<path d="M105.289 20.0994H107.313V32.2939H105.289V20.0994Z" fill="#39394C"/>
<path d="M119.999 28.3552V32.2939H117.975V28.8424L116.719 27.4668H112.743V32.2939H110.719V20.0994H118.152L119.929 21.8931V25.6381L118.656 26.909L119.999 28.3552ZM112.743 25.7949H117.239L117.937 25.0982V22.5029L117.239 21.8062H112.743V25.7949Z" fill="#39394C"/>
<path d="M0 8.7331L3.7113 15.1538C15.0829 33.3701 32.688 5.18971 35.074 0C35.0768 0 16.8086 29.2305 0 8.7331Z" fill="#FF4C55"/>
<path d="M7.52539 21.9243L14.0416 33.19C15.1835 35.1597 17.0463 35.1597 18.1854 33.19L36.0182 2.35876C31.5975 8.02292 21.4642 29.3816 7.52539 21.9243Z" fill="#FF4C55"/>
</g>
<defs>
<clipPath id="clip0_693_145">
<rect width="120" height="34.6667" fill="white"/>
</clipPath>
</defs>
</svg>
    </Link>
    

  )
}

export default Logo